import { pipe, String as Str } from 'effect';

// URL parameter prefixes for different filter types
export const URL_PREFIX = {
  checkbox: 'cb_',
  text: 'txt_',
  range: 'rng_',
} as const;

export type UrlPrefix = (typeof URL_PREFIX)[keyof typeof URL_PREFIX];

// Helper functions for URL prefix operations (reusable pattern from stateToApi)
const extractPrefix =
  (prefix: string) =>
  (str: string): string =>
    Str.startsWith(prefix)(str) ? Str.slice(prefix.length)(str) : str;

export const extractCheckboxCode = extractPrefix(URL_PREFIX.checkbox);
export const extractTextCode = extractPrefix(URL_PREFIX.text);
export const extractRangeCode = extractPrefix(URL_PREFIX.range);

export const prefixCheckbox = (code: string) => pipe(URL_PREFIX.checkbox, Str.concat(code));
export const prefixText = (code: string) => pipe(URL_PREFIX.text, Str.concat(code));
export const prefixRange = (code: string) => pipe(URL_PREFIX.range, Str.concat(code));

// URL parameter type detection
export const isCheckboxParam = (key: string): boolean => Str.startsWith(URL_PREFIX.checkbox)(key);
export const isTextParam = (key: string): boolean => Str.startsWith(URL_PREFIX.text)(key);
export const isRangeParam = (key: string): boolean => Str.startsWith(URL_PREFIX.range)(key);
export const isPaginationParam = (key: string): boolean => key === 'page' || key === 'itemsPerPage';
